import {
  SSOIntegrationProviderType,
  SingleSignOnTypes,
  ICreateOIDCIntegration,
  ICreateSamlIntegration,
  SamlIntegration,
  Oauth2Integration,
  CreateOauth2Integration,
  OIDCIntegration,
} from '@/types/registration.types';
import { Get, Post, Put, Patch } from '../helpers';

export function UpdateOIDCIntegration(data: ICreateOIDCIntegration): Promise<OIDCIntegration> {
  return Post({ path: `/v3/admin/channel/integrations/oidc`, body: data });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function GetSSOIntegrationsForChannel(channel: number): Promise<any> {
  return Get({ path: `/v3/admin/channel/sso/${channel}` });
}

export function GetSSOProviderDetails(
  channel: number,
  type: SingleSignOnTypes,
  ssoProvider: SSOIntegrationProviderType
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> {
  return Get({
    path: `/v3/admin/channel/sso-provider/${channel}/${type}?integrationType=${ssoProvider}`,
  });
}

export function UpdateSAMLIntegration(
  data: ICreateSamlIntegration,
  ssoProvider: SSOIntegrationProviderType
): Promise<ICreateSamlIntegration> {
  let route = `/v3/admin/channel/integrations/saml`;

  switch (ssoProvider) {
    case SSOIntegrationProviderType.JACKSON: {
      route = `/v3/admin/channel/integrations/saml-jackson`;
      break;
    }
    default: {
      break;
    }
  }

  // Bubble up the error message
  return Post({ path: route, body: data });
}

export function UpdateJacksonSAMLIntegration(data: ICreateSamlIntegration): Promise<SamlIntegration> {
  return Post({ url: `/v3/admin/channel/integrations/saml`, body: data });
}

export function ToggleOauthIntegration(channel: number, uuid: string, on: boolean): Promise<boolean> {
  return Put({ url: `/v3/admin/channel/oauth2/${channel}/${uuid}`, body: { on } });
}

export function ToggleAdminUseOauth2Integration(channel: number, uuid: string, on: boolean): Promise<boolean> {
  return Put({ url: `/v3/admin/channel/oauth2AdminLogin/${channel}/${uuid}`, body: { on } });
}

export function GetOauth2IntegrationForChannel(channel: number): Promise<Oauth2Integration | undefined> {
  return Get({ url: `/v3/admin/channel/oauth2/${channel}` });
}

export function CreateOauth2IntegrationForChannel(
  channel: number,
  integration: CreateOauth2Integration
): Promise<Oauth2Integration> {
  return Post({ path: `/v3/admin/channel/oauth2/${channel}`, body: { integration } });
}

export function UpdateOauth2Integration(channel: number, integration: Oauth2Integration): Promise<Oauth2Integration> {
  return Patch({ path: `/v3/admin/channel/oauth2/${channel}`, body: { integration } });
}
